import { DefaultTheme } from "styled-components";

export const lightTheme: DefaultTheme = {
  textColor: "#202020",
  bgColor: "#ffffff",

  contentBgColor: "#e9e9e9",
  hoverColor: "rgba(0, 0, 0, 0.3)",

  buttonTheme: "#f3f3f3",
};

export const darkTheme: DefaultTheme = {
  textColor: "#d9d9d9",
  bgColor: "#1e1f21",

  contentBgColor: "#2f3640",
  hoverColor: "rgba(225, 225, 225, 0.5)",

  buttonTheme: "#cdcdcd",
};
